// extracted by mini-css-extract-plugin
module.exports = {"wrapper-notification":"RsuiteNotification_wrapper-notification__0Pr3O"};